export default "__VITE_ASSET__CMZalh6G__"